import React, { useEffect } from "react";

export default function TermsOfService() {
  useEffect(() => {
    document.title = "ข้อกำหนดการให้บริการ - Encraft";
  }, []);

  return (
    <div className="content-container">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <h1 className="mb-2">ข้อกำหนดและเงื่อนไขการให้บริการ</h1>
            <p className="text-muted mb-4">
              เว็บไซต์ chicchiclawtutor.com • อัปเดตล่าสุด: 20 มกราคม 2569
            </p>

            <div className="card border">
              <div className="card-body p-4 p-md-5">
                <p className="mb-4">
                  เอกสารฉบับนี้กำหนดข้อกำหนดและเงื่อนไขในการใช้บริการเว็บไซต์{" "}
                  <strong>chicchiclawtutor.com</strong> (&quot;เว็บไซต์&quot;) ซึ่งให้บริการอ่านบทความกฎหมาย
                  ดูวิดีโอความรู้ด้านกฎหมายไทย คอร์สการเรียนการสอนกฎหมายไทย
                  และการเตรียมสอบราชการ การเข้าใช้งาน สมัครสมาชิก
                  หรือซื้อคอร์สใด ๆ บนเว็บไซต์นี้
                  ถือว่าคุณยอมรับและตกลงปฏิบัติตามข้อกำหนดและเงื่อนไขฉบับนี้
                </p>

                <hr />

                {/* 1. คำนิยาม */}
                <section className="mb-4">
                  <h2 className="h5">1. คำนิยาม</h2>
                  <ul>
                    <li><strong>&quot;เว็บไซต์&quot;</strong> หมายถึง chicchiclawtutor.com</li>
                    <li><strong>&quot;ผู้ใช้บริการ&quot;</strong> หมายถึง บุคคลที่เข้าถึงหรือใช้บริการ</li>
                    <li><strong>&quot;สมาชิก&quot;</strong> หมายถึง ผู้ที่สมัครบัญชีผู้ใช้</li>
                    <li>
                      <strong>&quot;คอร์สเรียน&quot;</strong> หมายถึง
                      เนื้อหาแบบมีค่าใช้จ่าย เช่น วิดีโอ เอกสาร แบบฝึกหัด
                    </li>
                    <li><strong>&quot;ผู้ให้บริการ&quot;</strong> หมายถึง ผู้ดูแลเว็บไซต์</li>
                  </ul>
                </section>

                {/* 2. ขอบเขตการให้บริการ */}
                <section className="mb-4">
                  <h2 className="h5">2. ขอบเขตการให้บริการ</h2>
                  <ul>
                    <li>บทความและความรู้ด้านกฎหมายไทย</li>
                    <li>วิดีโอและสื่อการเรียนรู้</li>
                    <li>คอร์สเรียนออนไลน์ด้านกฎหมายและการสอบราชการ</li>
                    <li>ระบบสมาชิก</li>
                  </ul>
                  <p className="mb-0">
                    เนื้อหาทั้งหมดจัดทำขึ้นเพื่อ <strong>การศึกษาและให้ความรู้ทั่วไป</strong>
                    ไม่ถือเป็นคำปรึกษาทางกฎหมายเฉพาะกรณี
                  </p>
                </section>

                {/* 3. การสมัครสมาชิก */}
                <section className="mb-4">
                  <h2 className="h5">3. การสมัครสมาชิกและบัญชีผู้ใช้</h2>
                  <ul>
                    <li>การเข้าถึงคอร์สเรียนจำเป็นต้องสมัครสมาชิก</li>
                    <li>ผู้ใช้ต้องให้ข้อมูลที่ถูกต้องและเป็นความจริง</li>
                    <li>ห้ามโอนหรือให้ผู้อื่นใช้งานบัญชีของตน</li>
                    <li>ผู้ใช้ต้องรับผิดชอบต่อกิจกรรมทั้งหมดที่เกิดจากบัญชีของตน</li>
                  </ul>
                </section>

                <section className="mb-4">
                  <h2 className="h5">3.1 การรักษาความปลอดภัยของบัญชีผู้ใช้</h2>

                  <p>
                    เพื่อรักษาความปลอดภัยของระบบและป้องกันการใช้งานที่ไม่เป็นไปตามข้อกำหนด
                    เว็บไซต์อาจจัดเก็บข้อมูลทางเทคนิคของอุปกรณ์ที่ใช้เข้าใช้งานบริการ
                    เช่น ประเภทอุปกรณ์ ระบบปฏิบัติการ ข้อมูลเบราว์เซอร์
                    วันและเวลาเข้าใช้งาน รวมถึงข้อมูลที่จำเป็นต่อการตรวจสอบความปลอดภัย
                    การป้องกันการแชร์บัญชี และการให้บริการแก่ผู้ใช้งาน
                  </p>

                  <p className="mb-0">
                    เว็บไซต์ขอสงวนสิทธิ์ในการตรวจสอบการเข้าใช้งานที่มีลักษณะผิดปกติ
                    และอาจดำเนินมาตรการที่เหมาะสมเพื่อป้องกันการใช้งานที่ขัดต่อข้อกำหนด
                    และเงื่อนไขการให้บริการของเว็บไซต์
                  </p>
                </section>

                {/* ⭐ 4. คอร์สเรียนและวิดีโอ (เพิ่มใหม่) */}
                <section className="mb-4">
                  <h2 className="h5">4. คอร์สเรียนและวิดีโอ</h2>
                  <ul>
                    <li>
                      คอร์สเรียนเป็นเนื้อหาเฉพาะบุคคล
                      ห้ามแชร์บัญชี ลิงก์ หรือเนื้อหาให้ผู้อื่น
                    </li>
                    <li>
                      ผู้ให้บริการขอสงวนสิทธิ์ในการปรับปรุง
                      เนื้อหา โครงสร้าง หรือรูปแบบของคอร์ส
                    </li>
                    <li>
                      ระยะเวลาการเข้าถึงคอร์สเป็นไปตามที่ระบุไว้ในหน้าคอร์สนั้น ๆ
                    </li>
                  </ul>
                </section>

                {/* ⭐ 5. การชำระเงินและการคืนเงิน (เพิ่มใหม่) */}
                <section className="mb-4">
                  <h2 className="h5">5. การชำระเงินและการคืนเงิน</h2>
                  <ul>
                    <li>ราคาคอร์สและค่าบริการแสดงไว้ชัดเจนก่อนการชำระเงิน</li>
                    <li>
                      การชำระเงินถือว่าสิ้นสุด
                      เว้นแต่จะมีการระบุเงื่อนไขคืนเงินเป็นกรณีเฉพาะ
                    </li>
                    <li>
                      เว็บไซต์ขอสงวนสิทธิ์ไม่คืนเงิน
                      หากผู้ใช้เข้าเรียนหรือเข้าถึงเนื้อหาแล้ว
                    </li>
                  </ul>
                </section>

                {/* 6. ลิขสิทธิ์ */}
                <section className="mb-4">
                  <h2 className="h5">6. ลิขสิทธิ์และทรัพย์สินทางปัญญา</h2>
                  <ul>
                    <li>เนื้อหาทั้งหมดเป็นทรัพย์สินทางปัญญาของ chicchiclawtutor</li>
                    <li>
                      ห้ามคัดลอก บันทึกหน้าจอ เผยแพร่
                      หรือใช้เพื่อการค้าโดยไม่ได้รับอนุญาต
                    </li>
                  </ul>
                </section>

                {/* 7. การระงับบัญชี */}
                <section className="mb-4">
                  <h2 className="h5">7. การระงับหรือยกเลิกบัญชี</h2>

                  <p>
                    เว็บไซต์มีสิทธิ์ระงับ จำกัด หรือยกเลิกการใช้งานบัญชีผู้ใช้
                    ทั้งหมดหรือบางส่วน หากพบการใช้งานที่ขัดต่อข้อกำหนดและเงื่อนไข
                    ของเว็บไซต์ หรือมีเหตุอันควรเชื่อได้ว่ามีการใช้งานที่อาจก่อให้เกิด
                    ความเสียหายต่อเว็บไซต์ ผู้ใช้บริการรายอื่น หรือระบบของเว็บไซต์
                  </p>

                  <ul>
                    <li>การแชร์บัญชีหรืออนุญาตให้บุคคลอื่นใช้งานบัญชีแทน</li>
                    <li>การพยายามหลีกเลี่ยงมาตรการรักษาความปลอดภัยของเว็บไซต์</li>
                    <li>การใช้งานที่มีลักษณะผิดปกติหรืออาจเข้าข่ายการใช้งานร่วมกันหลายบุคคล</li>
                    <li>การละเมิดลิขสิทธิ์หรือเผยแพร่เนื้อหาของคอร์สเรียนโดยไม่ได้รับอนุญาต</li>
                    <li>การกระทำอื่นใดที่ขัดต่อข้อกำหนดและเงื่อนไขการให้บริการ</li>
                  </ul>

                  <p className="mb-0">
                    ในกรณีที่มีความจำเป็นเพื่อความปลอดภัยของระบบ
                    เว็บไซต์อาจจำกัดการเข้าใช้งานบางส่วนของบริการ
                    จำกัดการเปลี่ยนอุปกรณ์ที่ใช้เข้าใช้งาน
                    ระงับสิทธิ์การเข้าถึงคอร์สเรียนเป็นการชั่วคราว
                    หรือดำเนินมาตรการอื่นที่เหมาะสมก่อนการพิจารณาระงับบัญชีถาวร
                  </p>
                </section>

                {/* 8. Disclaimer */}
                <section className="mb-4">
                  <h2 className="h5">8. การปฏิเสธความรับผิด</h2>
                  <p>
                    เว็บไซต์ไม่รับผิดชอบต่อความเสียหายใด ๆ
                    ที่เกิดจากการนำเนื้อหาไปใช้
                  </p>
                </section>

                {/* 10. กฎหมาย */}
                <section className="mb-4">
                  <h2 className="h5">9. กฎหมายที่ใช้บังคับ</h2>
                  <p>
                    ข้อกำหนดนี้อยู่ภายใต้กฎหมายไทย
                    และให้ศาลไทยเป็นศาลที่มีเขตอำนาจ
                  </p>
                </section>

                {/* 11. ติดต่อ */}
                <section className="mb-2">
                  <h2 className="h5">11. ช่องทางติดต่อ</h2>
                  <ul>
                    <li>Email: chicchiclawtutor@gmail.com</li>
                    <li>facrbook: พิชิตเนติฯ อัยการ ผู้พิพากษาแบบ chic chic</li>
                  </ul>
                </section>

                <p className="text-muted small mb-0">
                  การใช้งานเว็บไซต์ต่อไป ถือว่าคุณยอมรับข้อกำหนดฉบับนี้ทุกประการ
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
